
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pagebuilder",
      function () {
        return require("private-next-pages/pagebuilder/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pagebuilder"])
      });
    }
  